import React from 'react'
import { WidgetTeaserProps } from '@/types/cms'
import AppContext from '@/types/context'
import { Image } from '@/components/Image'
import styles from './TeaserSmall.module.scss'
import { Link } from '@/components/Link'
import SectionTitle from '@/components/SectionTitle/SectionTitle'
import { clsx } from 'clsx'
import TypeVisualizer from '@/elements/widgets/Teaser/components/TypeVisualizer/TypeVisualizer'
import SportTagLogo from '@/elements/widgets/Teaser/components/SportTagLogo/SportTagLogo'
import LiveLabel from '@/elements/widgets/Teaser/components/LiveLabel/LiveLabel'
import TransfertickerLogo from '@/elements/widgets/Teaser/components/TransfertickerLogo/TransfertickerLogo'
import { AreaItem } from '@/types/cms/AreaItem'

const TeaserSmall = ({
  item,
  inline,
}: {
  item: WidgetTeaserProps | AreaItem
  context: AppContext
  inline?: boolean
}) => {
  const isOnePerLine = item.model?.fields?.variant === 'one-per-line'

  return (
    <section
      className={clsx(
        styles.section,
        inline && styles.inline,
        isOnePerLine && clsx(styles['one-per-line'], 'small-one-per-line-teaser'),
      )}
    >
      {item.model?.fields?.headline && (
        <SectionTitle
          title={item.model?.fields?.headline}
          link={item.model?.fields?.link as any}
          className={clsx(styles['section-title'], inline && styles['inline-title'])}
        />
      )}
      <div className={clsx(styles.container, inline && styles.inline, isOnePerLine && styles['one-per-line'])}>
        {item.items?.map((teaser, index) => {
          return (
            <article
              key={index}
              title={teaser.model.headline ?? teaser.model.title}
              className={styles.article}
              data-cy={`teaser-small-${teaser.id}`}
            >
              <Link
                href={
                  teaser.model.type === 'teaserexternal' && teaser.model.linkExternal
                    ? teaser.model.linkExternal?.url
                    : teaser.model.url
                }
                target={
                  teaser.model.type === 'teaserexternal' && teaser.model.linkExternal
                    ? teaser.model.linkExternal?.target
                    : '_self'
                }
                className={styles.link}
                data-cy={`teaser-small-${teaser.id}_link`}
              >
                <div className={styles['image-container']}>
                  <Image
                    image={teaser.model.image}
                    alt={teaser.model.image?.filename || teaser.model.title}
                    className={styles.image}
                    defaultWidth={204}
                    defaultHeight={204}
                    data-cy={`teaser-small-${teaser.id}_image`}
                  />
                  {teaser.model.homeSection === 'Der Sport-Tag' && (
                    <SportTagLogo className={styles['sport-tag-logo']} />
                  )}
                  {teaser.model.homeSection === 'Transfermarkt' && (
                    <TransfertickerLogo
                      className={styles['transferticker-logo']}
                      data-cy={`teaser-small-${teaser.id}_transferticker-logo`}
                    />
                  )}
                  <LiveLabel
                    url={teaser?.model?.linkExternal?.url}
                    position="bottom-right"
                    className={styles['live-label']}
                  />
                  <TypeVisualizer item={teaser as any} position="bottom-right" className={styles['type-visualizer']} />
                </div>
                <div className={styles['text-column']}>
                  <h3 className={styles.headline} data-cy={`teaser-small-${teaser.id}_headline`}>
                    {teaser.model.headline}
                  </h3>
                  {!item?.model?.fields?.hideSection && (
                    <span className={styles['section-label']} data-cy={`teaser-small-${teaser.id}_section`}>
                      {teaser.model.homeSection}
                    </span>
                  )}
                </div>
              </Link>
            </article>
          )
        })}
      </div>
    </section>
  )
}

export default TeaserSmall
